<template>
    <cell
        :background="'bg-white hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-800'"
        :class="'sticky left-0 z-20'"

    >
        {{ $t('general.actions') }}
    </cell>
</template>

<script>
import Cell from '@/Components/Storemanager/InitialColumn/Cell';

export default {
    components: {Cell},
};
</script>
